<div *ngIf="petdocument">
    <div class="card">
    <div class="row" style="margin-top:5px" *ngFor=" let data of petdocument  | paginate: { itemsPerPage: 3, currentPage: p }">
        <div class="col-4 text-center"  *ngIf= "getFileExtension(data.path) === 'png' 
        || getFileExtension(data.path) === 'jpg'  || getFileExtension(data.path) === 'bmp' ||
         getFileExtension(data.path) === 'gif' ; else textimage">
         <img class="avatar1 "  src="https://passport.petcart.in/images/petimages/{{data.path}}">
        </div>
        <div class="col-4 text-center">{{data.document_type}}</div>
        <div class="col-4 text-center">
            <a href="https://passport.petcart.in/images/petimages/{{data.path}}" download>
              <mat-icon>file_download</mat-icon>
             </a>
        </div>
      </div>
    </div>
    </div>
    <div class="col-12 text-right">
            <pagination-controls  (pageChange)="p = $event"></pagination-controls >
    </div>
    <div class="row">
        <div class="col-12">
            <button class="btn btn-success btn-block" mat-dialog-close >Close</button>
        </div>
    </div>
    <ng-template #textimage>
        <div class="col-sm-4 col-md-2 col-lg-2 col-xl-2 text-center">
            <img class="avatar1 " src="https://passport.petcart.in/images/petimages/doc.png">
        </div>
        
    </ng-template>